import { render, staticRenderFns } from "./ShippingSelect.vue?vue&type=template&id=ee2ef0ac"
import script from "./ShippingSelect.vue?vue&type=script&lang=js"
export * from "./ShippingSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports